import styled from "styled-components";

export const LeftSection = styled.div`
  width: 100%;
  background: rgb(15, 22, 36);
`;
